module.exports = __webpack_public_path__ + "img/ProgrammerAnalyst.69dfa275.jpg";